import { useSuspenseGqlQuery } from "@/lib/GraphQLCodegen/fetcher";
import { contactRecordQuery } from "@/app/Contacts/GraphQL/contactRecordQuery";
import { useSearch } from "@tanstack/react-router";

export function useContactDrawer() {
  const search = useSearch({
    from: "/$tenant/$orgId/supplier/{-$supplierId}",
  });

  if (!search.contactId) {
    throw new Error("Contact id is not present in the search params");
  }

  const { data } = useSuspenseGqlQuery(contactRecordQuery, {
    id: search.contactId,
  });

  return data.contact;
}
